export default __webpack_public_path__ + "static/media/DevicesIcon.95569436.svg";